var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_3776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.229C24 5.60158 18.6274 0.229004 12 0.229004C5.37258 0.229004 0 5.60158 0 12.229C0 18.2185 4.3882 23.183 10.125 24.0832V15.6978H7.07812V12.229H10.125V9.58526C10.125 6.57776 11.9166 4.9165 14.6576 4.9165C15.9701 4.9165 17.3438 5.15088 17.3438 5.15088V8.104H15.8306C14.34 8.104 13.875 9.02908 13.875 9.979V12.229H17.2031L16.6711 15.6978H13.875V24.0832C19.6118 23.183 24 18.2185 24 12.229Z",
    fill: "#313E4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_3776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.229004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1523242fa462d5c1b1bb8cc6c0bc05b4.svg";
export { ForwardRef as ReactComponent };